import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import { ANALYTICS_COPY } from '../../constants/analyticsCopy';

export default function ScopeContextBanner({
  formName = '',
  serviceName = '',
  businessFunctionName = '',
  sx,
}) {
  return (
    <Box sx={sx?.scopeContextBanner}>
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <Box sx={sx?.chartTypeIconWrap}>
          <TableChartOutlinedIcon fontSize="small" />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle2" fontWeight={600}>
            {ANALYTICS_COPY.tableContextTitle}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            {ANALYTICS_COPY.tableContextSubtitle}
          </Typography>
          <Stack direction="row" flexWrap="wrap" gap={0.75} sx={{ mt: 1.25 }}>
            {businessFunctionName ? (
              <Chip size="small" label={businessFunctionName} variant="outlined" />
            ) : null}
            {serviceName ? (
              <Chip size="small" label={serviceName} variant="outlined" />
            ) : null}
            {formName ? (
              <Chip size="small" label={formName} color="primary" variant="outlined" />
            ) : null}
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}
